var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSyncDesignicon = function SvgSyncDesignicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.1 12c0 .16-.08.32-.16.4l-3.16 3.08c-.16.16-.4.16-.56 0l-.56-.56c-.16-.08-.16-.4.08-.56l1.72-1.72H4.3c-.24 0-.4-.16-.4-.4v-.8c0-.24.16-.4.4-.4h8.16l-1.72-1.72a.387.387 0 0 1 0-.56l.56-.56c.16-.16.4-.16.56 0l3.08 3.08c.08.08.16.24.16.4V12ZM.9 4.2c0-.16.08-.32.16-.4L4.22.72c.16-.16.4-.16.56 0l.56.56c.16.08.16.4-.08.56L3.54 3.56h8.16c.24 0 .4.16.4.4v.8c0 .24-.16.4-.4.4H3.54l1.72 1.72c.16.16.16.4 0 .56L4.7 8c-.16.16-.4.16-.56 0L1.06 4.92a.611.611 0 0 1-.16-.4V4.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgSyncDesignicon;